import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();
  const isAdmin = sessionStorage.getItem("isAdmin"); // "true" or "false"

  useEffect(() => {
    document.body.classList = "";
    document.body.classList.add("pageNotFound");
  }, []);

  
  // Yaha decide hoga ki kisko kahan bhejna hai
  const homeRoute = isAdmin === "true" ? "/merchant-list" : "/dashboard";

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-white to-slate-100 px-6">
      <div className="max-w-4xl w-full bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-gray-100 p-8 md:p-12">
        <div className="flex flex-col md:flex-row items-center gap-8">
          <div className="flex-shrink-0">
            <div className="w-40 h-40 md:w-48 md:h-48 flex items-center justify-center rounded-xl bg-gradient-to-tr from-red-100 to-red-300 ring-1 ring-red-200">
              <div className="text-center">
                <h1 className="text-5xl md:text-6xl font-extrabold text-red-600 leading-none">404</h1>
                <p className="mt-1 text-sm text-red-700 font-medium">Page not found</p>
              </div>
            </div>
          </div>

          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-semibold text-slate-800">
              Oops — we cannot find that page
            </h2>

            <p className="mt-3 text-slate-600">
              The page you're looking for may have been moved or does not exist.
            </p>

            <div className="mt-6">
              <Link
                to={homeRoute}
                className="inline-flex items-center justify-center px-4 py-2 rounded-lg bg-slate-900 text-white text-sm font-medium hover:opacity-95 transition"
              >
                Take me home
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-8 text-xs text-slate-400 text-center">
          Tip: Add a catch-all route (path='*') to handle unknown pages.
        </div>
      </div>
    </div>
  );
}
